(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('policyRuleModes', ["feature", function (feature) {
        var data = [
            {
                autoId: 'policy_rule_edit_mode_dropdown_item_inline',
                id: 'inline',
                label: 'Protect (inline)',
                labelShort: 'Protect',
                workflow: true
            },
            {
                autoId: 'policy_rule_edit_mode_dropdown_item_normal',
                id: 'normal',
                label: 'Detect and Prevent',
                workflow: true
            },
            {
                autoId: 'policy_rule_edit_mode_dropdown_item_alert',
                id: 'alert',
                label: 'Monitor only'
            },
            {
                autoId: 'policy_rule_edit_mode_dropdown_item_block',
                id: 'block',
                label: 'Block'
            }
        ];
        if (feature.checkpointTheme) {
            data = [
                {
                    autoId: 'policy_rule_edit_mode_dropdown_item_inline',
                    id: 'inline',
                    label: 'Prevent (inline)',
                    labelShort: 'Prevent',
                    workflow: true
                },
                {
                    autoId: 'policy_rule_edit_mode_dropdown_item_normal',
                    id: 'normal',
                    label: 'Detect and Remediate',
                    workflow: true
                },
                {
                    autoId: 'policy_rule_edit_mode_dropdown_item_alert',
                    id: 'alert',
                    label: 'Detect'
                },
                {
                    autoId: 'policy_rule_edit_mode_dropdown_item_block',
                    id: 'block',
                    label: 'Block'
                }
            ];
        }
        var policyRuleModes = {
            data: data,
            get: function (id) {
                var found = _(data).find(function (res) {
                    return res.id == id;
                });
                if (!found) {
                    return {
                        id: id,
                        label: id.charAt && id.charAt(0).toUpperCase() + id.slice(1) || id
                    };
                }
                return found;
            },
            label: function (id) {
                return policyRuleModes.get(id).label;
            },
            labelShort: function (id) {
                var mode = policyRuleModes.get(id);
                return mode.labelShort || mode.label;
            }
        };
        return policyRuleModes;
    }]);
}());